<template>
    <div class="flex flex-col items-center gap-3">
        <div
            role="progressbar"
            :aria-valuenow="percentage"
            aria-valuemin="0"
            aria-valuemax="100"
            :aria-valuetext="message"
            class="overflow-hidden h-2 bg-valence-primary-500/25 rounded-full mx-auto w-36 contextMeter">
            <div class="transition-[width] duration-300 h-2 rounded-full bg-valence-primary-500" :style="{ width: `${percentage}%` }"></div>
        </div>
        <Transition name="fade" mode="out-in" appear>
            <div :key="message" class="min-h-6 body text-valence-primary-500">{{ message }}</div>
        </Transition>
    </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
    percentage: { type: Number, default: 1 },
    currentCheckpoint: { type: Number, default: -1 },
    messageStack: {
        type: Array,
        default: () => [
            "Can you tell me more?",
            "Great start! Any specific examples?",
            "I'm getting a clearer picture. Anything else?",
            "Excellent detail! This helps me understand deeply.",
        ],
    },
});

const message = computed(() => props.messageStack[props.currentCheckpoint] ?? "");
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 300ms ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
